import { ANNOTATION_INFRACOST_PROJECT } from '../utils/constants/annotations.esm.js';

const isInfracostAvailable = (entity) => Boolean(entity.metadata.annotations?.[ANNOTATION_INFRACOST_PROJECT]);

export { isInfracostAvailable };
//# sourceMappingURL=isInfracostAvailable.esm.js.map
